import React from 'react';
import { useReveal } from '../lib/useReveal';
const MORE_TESTIMONIALS = [{
  initials: 'CR',
  name: 'Cecilia R.',
  province: 'Mendoza',
  stars: 5,
  text: 'El Tomo 3 de emociones fue el más importante de mi vida. Nunca nadie me había explicado qué le pasa al cuerpo cuando el estrés se vuelve crónico. Lo leí llorando y subrayando cada página. Sentí que alguien finalmente me entendía.'
}, {
  initials: 'SC',
  name: 'Sofía C.',
  province: 'La Plata',
  stars: 5,
  text: 'El Kit Ritual Premium me salvó. Soy de las que empieza y abandona. Pero el programa de 21 días me dio la estructura que necesitaba. El día 7 me miré al espejo y algo había cambiado. No sé explicarlo. Pero se sentía diferente.'
}, {
  initials: 'PA',
  name: 'Paula A.',
  province: 'Neuquén',
  stars: 5,
  text: 'El Bono del Diario Emocional cambió mis mañanas para siempre. Son literalmente 5 minutos pero cambian el tono de todo el día. La escala emocional me ayuda a identificar qué siento antes de que se convierta en una crisis.'
}, {
  initials: 'JM',
  name: 'Julia M.',
  province: 'Rosario',
  stars: 5,
  text: 'El Tomo 5 de vínculos y pareja fue lo que más necesitaba y menos esperaba. Llevábamos meses distanciados sin saber cómo nombrarlo. Empecé a usar la comunicación no violenta y en dos semanas algo se movió entre nosotros.'
}, {
  initials: 'MV',
  name: 'María V.',
  province: 'Tucumán',
  stars: 5,
  text: 'Compré el MegaPack con el Kit Ritual. El programa de 21 días fue lo mejor. Cada día era manejable. Nunca me sentí abrumada. Y al día 21 hice el ritual de cierre llorando de gratitud. Nunca pensé que un PDF me iba a transformar así.'
}, {
  initials: 'GR',
  name: 'Gabriela R.',
  province: 'Santa Fe',
  stars: 5,
  text: 'Lo que más me impactó fue el trabajo con el chakra sacro del Tomo 4. Llevaba años con tensión en esa zona y nunca lo había conectado con todo lo que guardaba emocionalmente. Los 10 minutos de movimiento de caderas se convirtieron en mi práctica diaria.'
}];
function StarRating({
  count
}: {
  count: number;
}) {
  return <div className="flex gap-0.5" data-id="element-184">
      {Array.from({
      length: count
    }).map((_, i) => <span key={i} className="text-brand-accent text-sm" data-id="element-185">
          ⭐
        </span>)}
    </div>;
}
function TestimonialCard({
  initials,
  name,
  province,
  stars,
  text,
  index
}: {
  initials: string;
  name: string;
  province: string;
  stars: number;
  text: string;
  index: number;
}) {
  const [ref, vis] = useReveal();
  return <div ref={ref} className={`reveal bg-brand-card border border-brand-border-soft rounded-xl p-5 sm:p-6 flex flex-col gap-3 transition-all duration-500 hover:border-brand-accent hover:shadow-medium shadow-soft ${vis ? 'is-visible' : ''}`} style={{
    transitionDelay: `${index * 100}ms`
  }} data-id="element-186">
      <div className="flex items-center justify-between mb-1" data-id="element-187">
        <div className="flex items-center gap-2" data-id="element-188">
          <div className="w-8 h-8 rounded-full bg-brand-alternate border border-brand-border-soft flex items-center justify-center flex-shrink-0" data-id="element-189">
            <span className="text-brand-heading font-bold text-xs" data-id="element-190">
              {initials}
            </span>
          </div>
          <StarRating count={stars} data-id="element-191" />
        </div>
      </div>
      <p className="text-brand-body font-display text-base sm:text-lg leading-relaxed flex-grow italic" data-id="element-192">
        "{text}"
      </p>
      <div className="pt-3 border-t border-brand-border-soft" data-id="element-193">
        <p className="text-brand-heading text-sm font-semibold" data-id="element-194">
          {name} — {province}
        </p>
      </div>
    </div>;
}
export function MoreTestimonialsSection() {
  const [ref, vis] = useReveal();
  return <section className="bg-brand-alternate py-8 md:py-10 px-4 sm:px-6 border-t border-brand-border-soft" data-id="element-195">
      <div className="container mx-auto max-w-5xl" data-id="element-196">
        <div ref={ref} className={`reveal text-center mb-6 ${vis ? 'is-visible' : ''}`} data-id="element-197">
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-brand-heading tracking-wide" data-id="element-198">
            ❤️ MÁS MUJERES QUE YA LO TIENEN
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-199">
          {MORE_TESTIMONIALS.map((t, i) => <TestimonialCard key={i} {...t} index={i} data-id="element-200" />)}
        </div>
      </div>
    </section>;
}